import React, { createContext, useState, useContext, useEffect} from 'react'

// Create the context
const Context = createContext();


export function ContextProvider({ children }){

const [ selectedPatient, setSelectedPatient ] = useState(() => {
  const savedPatient = localStorage.getItem('patient_id')

  return savedPatient ? Number(savedPatient) : undefined
})
const [ selectedPatientData, setSelectedPatientData ] = useState(() => {
  const savedData = localStorage.getItem('patient_data')
  
  return savedData ? [JSON.parse(savedData)] : undefined
})

const [ doctorPage, setDoctorPage ] = useState(() => {
  const savedDoctorPage = localStorage.getItem('doctor_page')

  return savedDoctorPage ? savedDoctorPage : undefined
})

const [ adminPage, setAdminPage ] = useState(() => {
  const savedAdminPage = localStorage.getItem('admin_page')

  return savedAdminPage ? savedAdminPage : undefined
})


const [ selectedDocument, setSelectedDocument ] = useState(undefined)
const [ documentURL, setDocumentURL ] = useState(undefined)
const [ documentURLType, setDocumentURLType ] = useState(undefined)


  return (
    <Context.Provider value={{ selectedPatient, setSelectedPatient, selectedPatientData, 
    setSelectedPatientData, doctorPage, setDoctorPage, adminPage, setAdminPage, selectedDocument, setSelectedDocument,
    documentURL, setDocumentURL, documentURLType, setDocumentURLType }}>
        {children}
    </Context.Provider>
  )
}

export function useStateContext(){
    return useContext(Context);
}
